module.exports = __webpack_public_path__ + "static/media/section-one.a84977d7.png";